import * as Sentry from "@sentry/vue";
import { BrowserTracing, Replay } from "@sentry/browser";
import { App } from "vue";
import router from "@/router";
import { authStore } from "@/store/auth";
import { deviceModule } from "@/store/device";
import { APP_SERVICE_NAME } from "@/const/app";
import { fetchVersionFromDocument } from "@/app-updator";

export const initSentry = (app: App<Element>) => {
  Sentry.init({
    app,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    enabled: process.env.VUE_APP_SENTRY_ENVIRONMENT === "prod",
    replaysOnErrorSampleRate: 0.001,
    replaysSessionSampleRate: 0.000001,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [
          process.env.VUE_APP_SENTRY_TARGET_ORIGIN as string,
          /^\//
        ]
      }),
      new Replay({
        errorSampleRate: 0.001,
        sessionSampleRate: 0.000001,
        blockAllMedia: false, // メディアをブロックしない
        maskAllText: false, // テキストをマスクしない
        maskAllInputs: false // 入力をマスクしない
      })
    ],
    tracePropagationTargets: [process.env.VUE_APP_API_URL_BASE as string],
    attachStacktrace: true,
    tracesSampleRate: 0.001
  });
};

export const captureException = (error: Error | string) => {
  console.log("captureException", error);
  if (`${process.env.VUE_APP_SENTRY_ENVIRONMENT}`.match(/local/)) {
    console.log("ローカル環境なのでSentryへの送信はスキップします");
    return;
  }
  Sentry.captureException(
    typeof error === "string" ? new Error(error) : error,
    {
      extra: {
        buildVersion: fetchVersionFromDocument(),
        versionNo: deviceModule.versionNo,
        service: APP_SERVICE_NAME,
        userid: authStore.user?.id,
        username: authStore.user?.username
      }
    }
  );
};
